module.exports = __webpack_public_path__ + "img/it.456b5eb8.png";